export default __webpack_public_path__ + "static/media/BigCola.f3e768ac.png";